/**
 * Utility class for the lesson json data.
 */
export default class LessonJsonUtil {

  static getInteractionById(interactionId, lessonJson) {
    for (let interaction of lessonJson.interactions) {
      if (interaction.interactionId === interactionId) {
        return interaction;
      }
    }
    return null;
  }
}
